/**
 * One client-header cell of a listing row (TRA-1397). The em dash is the
 * empty-cell placeholder, as in the Trace cell.
 */

import { TableCell } from '@/components/ui/table'

export function ClientMetaCell({ value }: { value: string | null }): React.JSX.Element {
  if (value === null) {
    return <TableCell className="text-xs text-muted-foreground">—</TableCell>
  }
  return (
    <TableCell className="max-w-[160px] font-mono text-xs">
      <span className="block truncate" title={value}>
        {value}
      </span>
    </TableCell>
  )
}
